<div mat-dialog-content>
  <div class="flex flex-col">
    <div class="flex flex-row pb-4">
      <button class="ml-auto" type="button" mat-button color="primary" (click)="exportPDF()">Export PDF</button>
    </div>
    <div class="pdf-document pdf-preview"><ng-container [ngTemplateOutlet]="licenseTemplate"
                  [ngTemplateOutletContext]="{export: false}"></ng-container></div>

    <button class="ml-auto" type="button" mat-button color="warn" (click)="close()">Close</button>
  </div>
</div>

<div class="print-outer">
  <div class="print-inner">
    <kendo-pdf-export #pdf [paperSize]="'letter'" margin="1cm">
      <ng-container [ngTemplateOutlet]="licenseTemplate"
                    [ngTemplateOutletContext]="{export: true}"></ng-container>
    </kendo-pdf-export>
    </div>
</div>

<ng-template #licenseTemplate let-export="export">
  <div class="flex flex-col h-full gap-6">
    <div class="flex flex-row items-center">
      <img class="w-1/2 h-1/2" src="assets/images/OHA-Color.png" alt="Oregon Health Authority Logo">
      <img class="w-1/5 h-1/5 ml-auto" src="assets/images/ORSeal1.png" alt="Oregon Health Authority Seal">
    </div>
    <span class="font-semibold text-xl">Oregon Health Authority, Hemodialysis Technician Program</span>
    <hr class="w-full">
    <span class="font-semibold text-2xl">{{license.applicantFirstName}} {{license.applicantLastName}}</span>
    <span class="text-xl">{{license.full? '' : 'Provisional'}} Hemodialysis Technician</span>
    <div class="flex flex-row">

      <div class="flex flex-col w-1/2">
        <div class="flex flex-row">
          <span class="font-semibold w-1/3">Number:</span>
          <span>{{license.licenseId}}</span>
        </div>
        <div class="flex flex-row">
          <span class="font-semibold w-1/3">Status:</span>
          <span>{{license.statuses[0].label}}</span>
        </div>
      </div>

      <div class="flex flex-col w-1/2">
        <div class="flex flex-row">
          <span class="font-semibold w-1/3">Issued:</span>
          <span>{{license.approvedDate | date}}</span>
        </div>
        <div class="flex flex-row">
          <span class="font-semibold w-1/3">Expires:</span>
          <span>{{license.expirationDate | date}}</span>
        </div>
      </div>

    </div>

    <div [ngClass]="export? 'pt-80' : ''">
      <span>
        Printed on {{today | date}}.
      </span>
    </div>
  </div>
</ng-template>
